export const categoryInfos = [
    {
      title: "Electronics",
      name: "electronics",
      imgLink:
        "https://images-na.ssl-images-amazon.com/images/G/01/AmazonExports/Fuji/2020/May/Dashboard/Fuji_Dash_TV_2X._SY304_CB432517900_.jpg",
       // "https://images-na.ssl-images-amazon.com/images/G/01/AmazonExports/Fuji/2021/June/Fuji_Quad_Keyboard_1x._SY116_CB667159063_.jpg"
    },
    {
      title: "Discover fashion trends",
      name: "women's clothing",
      imgLink:
        "https://images-na.ssl-images-amazon.com/images/G/01/softlines/shopbop/ingress/2023/March/mp_20230219_ff_desktopsinglecategory_desktop_379x304_1._SY304_CB612639047_.jpg",
    },
    {
      title: "Men's Clothing",
      name: "men's clothing",
      imgLink:
        "https://m.media-amazon.com/images/I/618bcm65ksL._AC_UL480_FMwebp_QL65_.jpg",
    },
    {
      title: "Jewelery",
      name: "jewelery",
      imgLink:
        "https://m.media-amazon.com/images/I/71r7eWuCsaL._AC_UL480_FMwebp_QL65_.jpg",
    },
  ];
  